import { render } from "./WechatPay.vue?vue&type=template&id=043622c2"
import script from "./WechatPay.vue?vue&type=script&lang=js"
export * from "./WechatPay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__